import * as React from 'react';
 import TabContext from '@mui/lab/TabContext';
import { Container, Typography, Box, Button } from '@mui/material';
 
import TabPanel from '@mui/lab/TabPanel';
import AllDetails from './AllDetails';
import { Link } from 'react-router-dom'; 


const ExDetails = () => {

  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    
      <Box className='tab_one'>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <Container maxWidth='xl'>
            <Typography variant='h2' fontSize='45px' fontWeight='bold' paddingBottom='20px'>  Explore NFTs </Typography>

            <Box className='Exp_btn'>
              <Link to={'explore'}> <Button variant='contained'>View Explore</Button> </Link>
            </Box>


            <TabContext value={value}> 
              <TabPanel value="1" className='sathsmunder'>
                <AllDetails />
              </TabPanel> 
            </TabContext>
          </Container>
        </Box>
      </Box>
     
  )
}

export default ExDetails;